<!-- Property of OSF Global Services, Inc., (with its brand OSF Commerce). OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein. -->
<style scoped>
.question-title {
    font-weight: 400;
}
.answerItem {
    display: flex;
    justify-content: center;
    flex: 1 0 calc(100% / var(--nbAnswers));
    padding: 0.625rem 0;
    cursor: pointer;
    position: relative;
}
.answerItem:first-child .answer-titles {
    position: relative;
    left: 50%;
    max-width: 70%;
    text-align: left;
    align-self: flex-start;
}
.answerItem:last-child .answer-titles {
    position: relative;
    right: 50%;
    max-width: 70%;
    align-self: end;
}

.answer__left {
    display: flex;
    flex-direction: column-reverse;
    width: 100%;
}
.answer-icons {
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: center;
}
.answer-button {
    width: 2.375rem;
    height: 2.375rem;
    background: transparent;
    border: 0;
    position: relative;
}
.answer-button:before {
    content: "";
    width: 0.0625rem;
    height: 1rem;
    background-color: #cdcdcd;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
}
.answer__circle {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 0.125rem solid #fff;
    border-radius: 50%;
    padding: 0.4375rem;
}

.selected .selector {
    position: absolute;
    border: 0.125rem solid #000;
    width: 1.375rem;
    height: 1.375rem;
    border-radius: 50%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.answer__line {
    width: 100%;
    border-top: 0.0625rem solid #cdcdcd;
    bottom: 1.675rem;
    left: 50%;
    position: absolute;
}

.answer-titles {
    margin-bottom: 1rem;
}

.answerItem:last-of-type .answer__line {
    display: none;
}
.answersWrapper {
    width: 100%;
    min-width: 25rem;
    margin-top: 2.5rem;
    display: inline-flex;
    justify-content: center;
    position: relative;
    padding: 0;
    margin-bottom: 0;
}

.answersWrapper::before {
    content: "";
}

.answersWrapper::after {
    content: "";
}
.template6wrapper {
    padding-bottom: 15rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.answer_title {
    display: none;
}
.answer_subtitle {
    display: none;
}
.answer__title:hover {
    color: #cdcdcd;
}

@media (max-width: 767px) {
    .template6wrapper {
        padding-bottom: 7.5rem;
    }
    .answersWrapper {
        flex-direction: column;
        width: auto;
        align-items: flex-start;
        min-width: 0;
        margin-top: 0.5rem;
        min-height: 25rem;
        margin-left: -1rem;
    }
    .answerItem:first-child .answer-titles {
        left: auto;
        align-self: center;
    }
    .answerItem:last-child .answer-titles {
        right: auto;
        align-self: center;
    }
    .answer__left {
        flex-direction: row;
    }
    .answer-icons {
        align-items: center;
    }
    .answer-titles {
        margin-bottom: 0;
        margin-left: 1.25rem;
        display: flex;
        align-items: center;
        text-align: start;
    }
    .answer__line {
        height: 100%;
        width: 0;
        border-left: 0.0625rem solid #cdcdcd;
        top: 50%;
        bottom: 0;
        left: 1.125rem;
    }
    .answer-button:before {
        content: "";
        height: 0.0625rem;
        width: 1rem;
        background-color: #cdcdcd;
        position: absolute;
        top: 50%;
        left: auto;
        right: 0;
        transform: translateY(-50%);
    }
}
</style>

<template>
    <div class="template6wrapper ti-fs-20 ti-font-regular pt-70 pt-md-200">
        <h1 v-if="question.title" class="question-title ti-fs-28 ti-fs-md-56" id="radio-group-label">{{ question.title }}</h1>
        <h2 v-if="question.subTitle">{{ question.subTitle }}</h2>
        <div
            v-for="answer in this.answers"
            :key="answer.id"
            class="answerText"
            v-bind:class="[answer.selected ? 'selected' : '', answer.disabled ? 'disabled' : '']"
        >
            <div class="answer_title">
                {{ answer.title }}
            </div>
            <div class="answer_subtitle">
                {{ answer.subTitle }}
            </div>
        </div>
        <ul class="answersWrapper" :style="answerStyle" role="radiogroup" aria-labelledby="radio-group-label">
            <li
                v-for="answer in this.answers"
                :key="answer.id"
                class="answerItem"
                v-bind:class="[
                    answer.selected && answer.isDefaultAnswer ? 'selected' : '',
                    answer.selected && !answer.isDefaultAnswer ? 'selected' : '',
                    answer.disabled ? 'disabled' : '',
                ]"
            >
                <div class="answer__left" v-on:click="selectAnswer(answer.id)">
                    <div class="answer-icons">
                        <button
                            :data-cbt="getDataCbtValue(answer.text)"
                            v-on:click="selectAnswer(answer.id)"
                            class="answer-button"
                            role="radio"
                            :aria-checked="answer.selected ? 'true' : 'false'"
                            :aria-label="answer.selected ? selectedButtonText + ' ' + answer.text : buttonText + ' ' + answer.text"
                        >
                            <div class="answer__circle ti-bg-color-silver"></div>
                        </button>
                        <div class="selector" v-show="!answer.disabled" />
                    </div>
                    <div class="answer-titles">
                        <div class="answer__title">
                            {{ answer.title }}
                        </div>
                        <div class="answer__subtitle">
                            {{ answer.subTitle }}
                        </div>
                    </div>
                </div>
                <div class="answer__line" />
            </li>
        </ul>
        <button :data-cbt=getDataCbtValue(buttonText) class="ti-btn ti-btn-third mt-16 w-auto px-50 position-relative" v-on:click="submitQuestion()">
            {{ buttonText }}
        </button>
    </div>
</template>

<script>
import { forIn } from "lodash";

export default {
    name: "Q6Template",
    computed: {
        quizData: function () {
            return this.$store.state.quizData;
        },
        question: function () {
            return this.$store.state.questionData;
        },
        answers: function () {
            return this.$store.state.questionData.answers;
        },
        buttonText: function () {
            return this.$store.state.quizData.translations.templateq6buttontext;
        },
        answerStyle() {
            return {
                "--nbAnswers": this.answers.length,
            };
        },
        setAnswerIdForCBT(aid) {
            this.answerID = aid;
        },
        getAnswerIdForCBT() {
            return this.answerID;
        },
        selectedButtonText: function () {
            return this.$store.state.quizData.translations.templateq1selectedbuttontext;
        }
    },
    methods: {
        selectAnswer: function (aid) {
            this.$store.commit("setAnswer", aid);
        },
        submitQuestion: function () {
            let answers = [];

            forIn(this.question.answers, function (answer) {
                if (answer.selected === true) {
                    answers.push(answer.id);
                }
            });

            let data = {
                quizid: this.quizData.quizid,
                qid: this.question.id,
                aid: answers,
            };
            this.$store.dispatch("submitQuestion", data);
        },
        getDataCbtValue: function () {
            let answerVal = "";

            forIn(this.$store.state.questionData.answers, function (answer) {
                if (answer.selected === true) {
                    answerVal = answer.title;
                }
            });

            let data = {
                "event" : "GiftFinderNavigation",
                "eventTypes": "click",
                "W-cat": "Gift Finder",
                "W-act": "Step 6",
                "W-lib": answerVal
            }

            return JSON.stringify(data);
        }
    }
};
</script>
